// @flow

import React, {memo, type Node} from 'react';

type Props = {|
  children: Node,
  hideSidebarOnMobile?: boolean,
  noSidebar?: boolean,
|};

const MainCol = ({children, noSidebar, hideSidebarOnMobile = false}: Props) => (
  <section
    className={
      noSidebar === true
        ? 'col-12'
        : `col-md-${
            hideSidebarOnMobile ? '12' : '9'
          } col-lg-9 col-xl-10 bg-white`
    }
  >
    <div className="row">
      <div className="col">{children}</div>
    </div>
  </section>
);

export default memo<Props>(MainCol);
